export enum AudioSampleRateEnum {
  CDQuality = 44100,
  Professional = 48000,
  HighDefinition = 96000,
}

export type AudioSampleRate =
  | AudioSampleRateEnum.CDQuality
  | AudioSampleRateEnum.Professional
  | AudioSampleRateEnum.HighDefinition;
